import script from "./ServicesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesComponent.vue?vue&type=script&setup=true&lang=js"

import "./ServicesComponent.vue?vue&type=style&index=0&id=5bcfbbbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bcfbbbd"]])

export default __exports__